export default __webpack_public_path__ + "static/donation-bear-animation-339b48babe2a401b4192edb881d6baaa.svg";